import React from "react";
import MultiSelectDropdown from "../../select/base/MultiSelectDropdown";
import { CONTRACT_SITUATIONS, CONTRACT_SITUATIONS_DEFAULT } from "../../../../util";

const situations = Object.values(CONTRACT_SITUATIONS);
const options = situations.map((situation) => ({
  label: `app.enuns.${situation}`,
  value: situation,
}));

const SelectContractSituations = ({
  setContractSituations,
  defaultSituations = CONTRACT_SITUATIONS_DEFAULT,
}) => {
  return (
    <MultiSelectDropdown
      title="app.contract.situations"
      values={options}
      defaultSelected={defaultSituations}
      onChange={setContractSituations}
    />
  );
};

export default React.memo(SelectContractSituations);
